import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./assets/scss/index.scss";
import { Providers } from "./Providers";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Providers>
    <App />
  </Providers>
);
